import { createBuiltInComponentMeta, withComponentMeta } from '../../internal/component-meta';
import { Text as TextComponent } from './Text';
export const Text = withComponentMeta(TextComponent, createBuiltInComponentMeta('Text'));
//# sourceMappingURL=index.js.map